import React, { useState, useEffect } from "react";
import { SidebarData } from "./SidebarData";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../../style/HomePageSidebar.css";

// HomepageSidebar.jsx
const HomepageSidebar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(window.location.pathname);

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", collapsed);
  }, [collapsed]);

  return (
    <div className={collapsed ? "Sidebar collapsed" : "Sidebar"}>
      <ul className="SidebarList">
        {SidebarData.map((val, key) => (
          <li
            className={`SidebarRow ${selected === val.link ? "active" : ""}`}
            key={key}
            onClick={() => {
              if (val.link === "#") {
                setCollapsed(!collapsed);
              } else {
                setSelected(val.link);
                navigate(val.link);
              }
            }}
          >
            <div id="icon">
              {selected === val.link ? val.filledIcon : val.outlinedIcon}
            </div>
            {!collapsed && <div id="title">{val.title}</div>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HomepageSidebar;